import protobuf from "protobufjs";
import pushNotifications from "./pushNotifications.json";

const root = protobuf.Root.fromJSON(pushNotifications);
export default root;
